import Translate from "@/components/common/Translate";
import { Statuses } from "@/types/graphql";

type UserStatusViewProps = {
  status: Statuses;
};

const UserStatusView = (props: UserStatusViewProps) => {
  switch (props.status) {
    case Statuses.Active:
      return (
        <span className="text-success">
          <Translate i18nKey="status.ACTIVE" />
        </span>
      );
    case Statuses.Inactive:
      return (
        <span className="text-danger">
          <Translate i18nKey="status.INACTIVE" />
        </span>
      );
    case Statuses.PaddingApproval:
      return (
        <span className="text-warning">
          <Translate i18nKey="status.PADDING_APPROVAL" />
        </span>
      );
  }
};

export default UserStatusView;